import * as React from "react";

function EnvelopeOpenDollarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M257.3 304c11.05 0 20-8.969 20-20v-10.3c22.36-4.793 38.21-18.53 41.83-39.43 7.484-43.28-34.03-55.19-56.33-61.56l-5.547-1.594C233.5 164.2 234.1 160.1 234.9 156.5c1.375-7.812 16.59-9.719 30.27-7.625 5.594.844 11.73 2.812 17.59 4.844 10.39 3.594 21.83-1.938 25.45-12.34 3.625-10.44-1.891-21.84-12.33-25.47-7.219-2.484-13.11-4.078-18.56-5.273V100c0-11.03-8.953-20-20-20s-20 8.969-20 20v9.992C214.9 114.8 199.1 128.8 195.5 149.7c-7.5 42.8 33.1 54.7 49.6 59.8l5.812 1.688c29.28 8.375 28.8 11.19 27.92 16.28C278.3 235.3 263.1 237.3 249.4 235.1c-6.9-1-15.8-4.2-23.7-7l-4.4-1.6c-10.4-3.6-21.9 1.8-25.5 12.2-3.7 10.4 1.7 21.8 11.3 25.5l4.266 1.5c7.758 2.789 16.38 5.59 25.06 7.512V284c.874 11 9.774 20 20.874 20zm219.5-89.8a35.237 35.237 0 0 0-22.56 8.168l-156.9 130.8c-22.68 18.9-59.8 18.91-82.49.002L57.8 222.3a35.249 35.249 0 0 0-22.56-8.168C15.78 214.2 0 229.9 0 249.4V448c0 35.3 28.65 64 64 64h384c35.35 0 64-28.67 64-64.01V249.4c0-19.5-15.8-35.2-35.2-35.2zM464 448c0 8.822-7.178 16-16 16H64c-8.822 0-16-7.178-16-16V276.7l136.1 113.4c20.2 16.7 45.7 26 71.9 26s51.75-9.224 71.97-26.02L464 276.7V448zM112 225.9V56c0-4.406 3.594-8 8-8h272c4.406 0 8 3.594 8 8v169.8l33.72-28.1c4.38-3.6 9.18-6.4 14.28-8.8V56c0-30.88-25.1-56-56-56H120C89.13 0 64 25.12 64 56v132.9c5.064 2.41 9.941 5.23 14.3 8.863L112 225.9z"
  }));
}

const ForwardRef = React.forwardRef(EnvelopeOpenDollarIcon);
export default ForwardRef;